export const isControllableElement = (
  node: Node,
): node is HTMLElement & {
  validationMessage?: string;
  hint?: string;
  hideDetails: boolean;
} => node instanceof HTMLElement && node.tagName.startsWith("OC-");
